<template>
  <div>
    <van-nav-bar
        left-arrow
        title="网点收益"
        @click-left="$router.go(-1)"
        left-text="">
    </van-nav-bar>
    <div style="padding-top: 50px" class="wxMyOrders">
      <div class="balance_header">
      </div>
      <div class="balance_tips" style="  box-shadow: 0 2px 12px rgb(100 101 102 / 12%) !important;">
        <div style="">
          <van-row class="user-links" style="padding-top: 40px">
            <van-col span="12">
              <div style="font-size: 19pt">{{ totalBalance }}</div>
              <div class="topCount">累计收入(元)</div>
            </van-col>
            <van-col span="12">
              <div style="font-size: 19pt">{{ lastBalance }}</div>
              <div class="topCount">待提现(元)</div>
            </van-col>
          </van-row>
        </div>
      </div>
      <div style="margin-top: 10px">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
          <div
              v-for="item in list"
              :key="item.id">
            <div class="kyzCard">
              <div>
                <div
                    class="van-doc-demo-block__title_k data">
                  <van-row>
                    <van-col span="18">
                      <div style="text-align: left;">下单时间：{{ item.createTime }}</div>
                    </van-col>
                    <van-col span="6">
                      <div style="text-align: right;color:red">状态：{{ item.cashsn === undefined ? '待提现' : '已提现' }}</div>
                    </van-col>
                  </van-row>
                </div>
                <div style="margin-top: 5px">
                  <van-row>
                    <van-col span="18">
                      <div style="color: black;font-size: 12pt;margin-left: 10px" class="line2">[{{
                          item.userName
                        }}] {{
                          item.prodName
                        }}
                      </div>
                    </van-col>
                    <van-col span="1">
                    </van-col>
                    <van-col span="5">
                      <div style="text-align: right;margin-right: 10px">
                        <div style="color: black;font-size: 12pt"> {{
                            item.typeFlag === 0 ? ('❤️ ' + item.amount) : ('¥ ' + item.amount)
                          }}
                        </div>
                        <div style="font-size: 10pt"></div>
                      </div>
                    </van-col>
                  </van-row>
                  <van-divider/>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import {
  NavBar, Divider,
  Button, Field, Tab, Tabs,
  List, Card
} from 'vant'
import {postAction} from '@/api/manage'

export default {
  components: {
    [Button.name]: Button, [Divider.name]: Divider,
    [List.name]: List, [Tab.name]: Tab, [Tabs.name]: Tabs,
    [Field.name]: Field, [NavBar.name]: NavBar, [Card.name]: Card,
  },

  data() {
    return {
      active: 0,
      list: [],
      loading: false,
      finished: false,
      pageNumber: 1,
      balanceLast: 0,
      kyz: this,
      totalBalance: 0,
      lastBalance: 0,
    }
  },
  mounted() {
    this.getBalance()
  },
  methods: {
    onLoad() {
      this.loadData()
    },
    refreshData(orderFlag) {
      this.finished = true
      var that = this;
      this.$nextTick(() => {
        that.loading = false
        that.finished = false
        that.pageNumber = 1
        that.list = []
        that.orderFlag = orderFlag
      })
    },
    getBalance() {
      const that = this
      //发送 post 请求
      postAction('/web/api/manager/wdAmount', {}).then(function (response) {
        console.log(response.result)
        that.totalBalance = response.result.totalBalance
        that.lastBalance = response.result.lastBalance
      }).finally(() => {
      })
    },
    types(tt) {
      if (tt == 0) {
        return '待提现'
      } else if (tt == 1) {
        return '已提现'
      }
    },
    loadData() {
      const that = this
      //发送 post 请求
      postAction('/web/api/manager/wdAmountRecord', {
        'pageNo': that.pageNumber,
      }).then(function (response) {
        console.log(response.result)
        // 异步更新数据
        for (let i = 0; i < 10; i++) {
          if (response.result.data.records[i]) {
            that.list.push(response.result.data.records[i])
          }
        }
        that.pageNumber = that.pageNumber + 1
        // 加载状态结束
        that.loading = false
        // 数据全部加载完成
        if (that.list.length >= response.result.data.total) {
          that.finished = true
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.van-card__bottom {
  padding-bottom: 20px;
}

.van-card__desc {
  margin-top: 6px;
}

.van-card__title {
  font-size: 11pt;
}

.wxMyOrders .van-card__price {
  font-size: 13pt !important;
}

.wxMyOrders .van-card__price-integer {
  font-size: 13pt !important;
}

.van-nav-bar {
  position: fixed;
  width: 100%;
}

.balance_header {
  background: url("/img/paysuccess-bg.png") no-repeat;
  background-size: 100%;
  height: 110px;
}

.balance_header .balance_amount {
  text-align: center;
  padding-top: 10px;
  font-size: 22pt;
  color: white
}

.balance_header .balance_zhan {
  text-align: center;
  padding-top: 0px;
  font-size: 11pt;
  color: white
}

.balance_tips {
  background-color: white;
  margin: -80px 20px 0px 20px;
  height: 120px;
  border-radius: 15px;
  text-align: center;
  line-height: 20px;
}

.kyzCard {
  background-color: white;
  color: #454545;
  font-size: 10pt;
  margin-bottom: 5px;
}

.kyzCard .data {
  margin: 0px 20px;
}

.kyzCard .kyzCardAmount {
  color: red;
  font-size: 21px;
  padding-top: 6px
}

.topCount {
  font-size: 10pt;
  margin-top: 12px;
  color: gray;
}
</style>
